import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ArrowUpRight } from 'lucide-react';
import { useRouter } from '../RouterContext';

const CrmPage: React.FC = () => {
  const { navigate } = useRouter();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.08 });

  return (
    <section style={s.section} ref={ref}>
      <div style={s.container}>
        <div style={s.split}>

          <motion.div
            style={s.textCol}
            initial={{ opacity: 0, y: 24 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.65 }}
          >
            <span style={s.productBadge}>CRM · Clientes · Leads · Negócios</span>
            <h2 style={s.title}>Nexo</h2>
            <p style={s.tagline}>O CRM feito para equipas que não têm tempo a perder.</p>
            <p style={s.body}>
              Desenvolvido pela 2GF, o Nexo é um CRM focado no essencial: ajudar equipas
              comerciais a gerir relações, acompanhar oportunidades e fechar mais negócio —
              sem configurações complexas nem funcionalidades que ninguém usa.
            </p>
            <p style={s.body}>
              Usado por 23 empresas portuguesas que precisam de organização comercial
              sem a complexidade dos sistemas enterprise.
            </p>
            <button onClick={() => navigate('nexo')} style={s.cta}>
              Saber mais <ArrowUpRight size={15} />
            </button>
          </motion.div>

          <motion.div
            style={s.imgCol}
            initial={{ opacity: 0, y: 24 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.65, delay: 0.15 }}
          >
            <div style={s.imgWrap}>
              <img
                src="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800&q=80&auto=format&fit=crop&crop=center"
                alt="Equipa a trabalhar"
                style={s.img}
              />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

const s: { [key: string]: React.CSSProperties } = {
  section: {
    background: '#ffffff',
    borderTop: '1px solid #E8EDF3',
    padding: '100px 0',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 2rem',
  },
  split: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '5rem',
    alignItems: 'center',
  },
  textCol: {},
  productBadge: {
    display: 'inline-block',
    fontFamily: "'IBM Plex Sans', sans-serif",
    fontSize: '0.7rem',
    fontWeight: 600,
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    color: '#64748B',
    background: '#F1F5F9',
    padding: '0.3rem 0.8rem',
    marginBottom: '1.25rem',
  },
  title: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontSize: 'clamp(2.5rem, 5vw, 4rem)',
    fontWeight: 900,
    color: '#0D1B2A',
    letterSpacing: '-0.03em',
    lineHeight: 1.05,
    marginBottom: '0.75rem',
  },
  tagline: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontSize: '1.05rem',
    fontWeight: 600,
    color: '#334155',
    lineHeight: 1.5,
    marginBottom: '1.25rem',
  },
  body: {
    fontSize: '0.95rem',
    color: '#64748B',
    lineHeight: 1.85,
    marginBottom: '1rem',
  },
  cta: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4rem',
    fontFamily: "'IBM Plex Sans', sans-serif",
    fontSize: '0.8rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#0057FF',
    background: 'none',
    border: 'none',
    borderBottom: '1px solid #0057FF',
    paddingBottom: '2px',
    marginTop: '0.5rem',
    cursor: 'pointer',
  },
  imgCol: {},
  imgWrap: {
    overflow: 'hidden',
    lineHeight: 0,
  },
  img: {
    width: '100%',
    height: '420px',
    objectFit: 'cover',
    display: 'block',
    filter: 'grayscale(15%)',
  },
};

export default CrmPage;
